import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import mixpanelConstants from '../constants/mixpanel';

export const setForgotEmail = createAction('SET_FORGOT_EMAIL');
export const setForgotMessage = createAction('SET_FORGOT_MESSAGE');
export const setForgotdisplay = createAction('SET_FORGOT_DISPLAY');
export const setSuccessdisplay = createAction('SET_SUCCESS_DISPLAY');
export const setSuccessMsg = createAction('SET_SUCCESS_MESSAGE');
export const resetForgot = createAction('RESET_FORGOT');
export const setIsLoading = createAction('SET_IS_LOADING');

const initialState = {
	display: 'none',
	email: '',
	isLoading: false,
	message: '',
	successdisplay: 'none',
	successmessage: ''
};

export default handleActions(
	{
		RESET_FORGOT: () => initialState,
		SET_FORGOT_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_FORGOT_EMAIL: (state, action) => ({ ...state, email: action.payload }),
		SET_FORGOT_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_IS_LOADING: (state, action) => ({ ...state, isLoading: action.payload }),
		SET_SUCCESS_DISPLAY: (state, action) => ({ ...state, successdisplay: action.payload }),
		SET_SUCCESS_MESSAGE: (state, action) => ({ ...state, successmessage: action.payload })
	},
	initialState
);

export const forgotPassword = () => {
	return function (dispatch, getState) {
		const { email } = getState().forgotPassword;
		Agent.forgotPassword(email).then((response) => {
			if (response.ok) {
				dispatch(setSuccessMsg('We have sent you an email with instructions to reset your password.'));
				dispatch(setSuccessdisplay('block'));
				dispatch(setForgotdisplay('none'));
				mixpanel.track(mixpanelConstants.REQUEST_RESET_PASSWORD_LINK, {
					email: email
				});
			} else {
				dispatch(
					setForgotMessage(
						'Failed to find account: ' + (response.data === null ? 'something went wrong' : response.data)
					)
				);
				dispatch(setForgotdisplay('block'));
				dispatch(setSuccessdisplay('none'));
			}
		});
	};
};
